export const nameSpace = 'customers';
